import { render, staticRenderFns } from "./UpgradeNotification.vue?vue&type=template&id=762e1071&scoped=true"
import script from "./UpgradeNotification.vue?vue&type=script&lang=js"
export * from "./UpgradeNotification.vue?vue&type=script&lang=js"
import style0 from "./UpgradeNotification.vue?vue&type=style&index=0&id=762e1071&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762e1071",
  null
  
)

export default component.exports